<template>
  <v-card
    flat
    height="100%"
    color="bglight"
  >
    <v-progress-linear
      :active="getGlobalLoadStatus"
      :indeterminate="getGlobalLoadStatus"
      absolute
      height="7"
      bottom
      color="second accent-4"
    ></v-progress-linear>
    <template v-if="!isLoading&&!isCompleted">
    <MainTab/>
    <!-- Depending on the Main Tab Value and the Product Selected Value -->
    <!-- we will display one of these components -->
    <SubTaskFrame v-if="getTabs.main == 'additionalInfo' ||
    (getTabs.main == 'products' && getProductIdSelected != null)"/>
    <ProductsFrame v-else-if="getTabs.main == 'products' && getProductIdSelected == null"/>
    <ReviewFrame v-else-if="getTabs.main == 'review'"/>
    <SignNSubmitFrame v-else-if="getTabs.main == 'signAndSubmit'"/>
    </template>
    <template v-else-if="isCompleted">
      <v-container class="pt-8">
        <Completed />
      </v-container>
    </template>
    <template v-else>
      <div class="pa-6">
        <div class="text-h4 text-center my-9">Loading...</div>
      </div>
    </template>
  </v-card>
</template>

<script>
import { mapGetters } from 'vuex';
import MainTab from '@/components/tabs/MainTab.vue';
import SubTaskFrame from '@/components/mainframes/SubTaskFrame.vue';
import ProductsFrame from '@/components/mainframes/ProductsFrame.vue';
import ReviewFrame from '@/components/mainframes/ReviewFrame.vue';
import SignNSubmitFrame from '@/components/mainframes/SignNSubmitFrame.vue';
import Completed from '@/components/mainframes/Completed.vue';

export default {
  name: 'Home',

  methods: {
    async loadForm() {
      const contractId = this.$route.params.contract_id;
      const accessKey = this.$route.params.access_key;
      const vm = this;
      vm.isLoading = true;
      try {
        await this.$store.dispatch('loadForm', { contractId, accessKey });
      } catch (e) {
        vm.$router.push({ name: 'Default' });
      } finally {
        vm.isLoading = false;
      }
    },
  },

  data: () => ({
    isLoading: true,
  }),

  mounted() {
    this.loadForm();
  },
  computed: {
    ...mapGetters(['getGlobalLoadStatus', 'getTabs', 'getProductIdSelected', 'isCompleted']),
    ...mapGetters(['getTabs', 'getProductIdSelected']),
  },
  components: {
    MainTab,
    SubTaskFrame,
    ProductsFrame,
    ReviewFrame,
    SignNSubmitFrame,
    Completed,
  },

};
</script>
